import React from 'react';
import ImageGeneratorBase from './ImageGeneratorBase';

interface ProfileImageGeneratorProps {
  backgroundUrl: string;
  backgroundName: string;
}

const ProfileImageGenerator: React.FC<ProfileImageGeneratorProps> = ({
  backgroundUrl,
  backgroundName
}) => {
  return (
    <ImageGeneratorBase
      backgroundUrl={backgroundUrl}
      backgroundName={backgroundName}
      variant="profile"
    />
  );
};

export default ProfileImageGenerator;
